<template>
  <div class="app-container">
    <div class="card">
      <el-form
        ref="form"
        :model="queryParams"
        :inline="true"
        @keyup.enter.native="handleQuery"
      >
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.unitName"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="证件编号：">
          <el-input
            v-model="queryParams.certificateNumber"
            placeholder="请输入证件编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="queryParams.status"
            placeholder="请选择客户状态"
            clearable
          >
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="handleReset">
            重 置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mainContainer">
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column prop="id" label="集团客户编号" align="center" />
          <el-table-column prop="unitName" label="企业名称" align="center" />
          <el-table-column
            prop="certificateType"
            label="证件类型"
            align="center"
          >
            <template slot-scope="{ row }">
              {{
                row.certificateType == 1
                  ? "营业执照"
                  : row.certificateType == 2
                  ? "医疗执业许可证"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column prop="delegate" label="委托人" align="center" />
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.status == 1 ? "启用" : "禁用" }}</span>
              <el-tooltip
                v-if="row.status == 2"
                effect="dark"
                :content="row.statusRemark || '无禁用原因'"
                placement="top"
              >
                <span class="status-reason-icon">?</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="建档日期" align="center" />
          <el-table-column
            prop="updateTime"
            label="最近一次更新时间"
            align="center"
          />
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="{ row }">
              <span class="btsed" @click="BusinessManage(row)">经营管理</span>
              <span class="btsed" @click="openShareDialog(row)">共享发送</span>
              <span
                class="btsed"
                v-if="row.status == 1"
                @click="openDisableDialog(row)"
              >
                禁用
              </span>
              <span class="btsed" v-else @click="enableCustomer(row)"
                >启用</span
              >
              <span class="btsed" @click="openSyncErpDialog(row)">同步ERP</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
    <CustInformation
      v-model="dialogVisible"
      :customerId="currentRow.id"
      entryMode="view"
      @submitted="onSubmitted"
      @closed="dialogVisible = false"
    />

    <ShareReceiveCompanyDialog
      v-model="shareDialogVisible"
      :customerId="shareCustomerId"
      @success="onShareSuccess"
    />
    <PushErpDialog
      v-model="syncErpDialogVisible"
      :customerId="syncErpCustomerId"
      @success="onSyncErpSuccess"
    />

    <el-dialog
      title="客户禁用"
      :visible.sync="disableDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="disableFormRef"
        :model="disableForm"
        :rules="disableRules"
        label-width="100px"
      >
        <el-form-item label="禁用原因：" prop="statusRemark">
          <el-input
            v-model="disableForm.statusRemark"
            type="textarea"
            :rows="6"
            maxlength="50"
            show-word-limit
            placeholder="请输入客户禁用原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDisableDialog">取 消</el-button>
        <el-button
          type="primary"
          :loading="disableLoading"
          @click="confirmDisable"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerList,
  statusCustomer, // 集团客户列表-启用禁用集团客户
} from "@/api/appApi/appapi.js";
import ShareReceiveCompanyDialog from "@/components/ShareReceiveCompanyDialog/index.vue";
import PushErpDialog from "@/components/PushErpDialog/index.vue";
export default {
  name: "",
  components: { ShareReceiveCompanyDialog, PushErpDialog },
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        unitName: "", //企业名称
        certificateNumber: "", //证件编号
        status: "", //状态（1:启用,2:禁用）
      },

      total: 0,
      loading: false,
      tableData: [], //列表

      dialogVisible: false, //经营管理更新弹窗
      currentRow: {}, //当前操作行

      shareDialogVisible: false,
      shareCustomerId: "",

      syncErpDialogVisible: false,
      syncErpCustomerId: "",

      disableDialogVisible: false,
      disableLoading: false,
      disableRow: null,
      disableForm: {
        statusRemark: "",
      },
      disableRules: {
        statusRemark: [
          { required: true, message: "请输入客户禁用原因", trigger: "blur" },
        ],
      },
    };
  },

  async created() {
    // 从手动匹配详情链接跳转时，自动打开客户资料弹窗
    await this.tryAutoOpenCustomer();
    await this.getList();
  },
  methods: {
    // 根据路由参数自动打开客户详情
    tryAutoOpenCustomer() {
      const { customerId, autoOpen, unitName, certificateNumber } =
        this.$route.query || {};
      if (autoOpen === "1" && customerId) {
        this.currentRow = { id: customerId };
        this.queryParams = {
          unitName: unitName || "",
          certificateNumber: certificateNumber || "",
        };
        this.$nextTick(() => {
          this.dialogVisible = true;
        });
      }
    },
    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      let res = await getCustomerList(this.queryParams);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    //经营管理更新弹窗
    BusinessManage(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    openDisableDialog(row) {
      this.disableRow = row;
      this.disableDialogVisible = true;
      this.disableForm.statusRemark = "";
      this.$nextTick(() => {
        this.$refs.disableFormRef && this.$refs.disableFormRef.clearValidate();
      });
    },
    closeDisableDialog() {
      this.disableDialogVisible = false;
      this.disableLoading = false;
      this.disableRow = null;
      this.disableForm.statusRemark = "";
    },
    async confirmDisable() {
      const valid = await this.$refs.disableFormRef
        .validate()
        .catch(() => false);
      if (!valid) return;
      if (!this.disableRow) return;
      this.disableLoading = true;
      const res = await statusCustomer({
        id: this.disableRow.id,
        status: 2,
        statusRemark: this.disableForm.statusRemark,
      }).catch(() => null);
      this.disableLoading = false;
      if (res && res.code == "000000") {
        this.$message.success(res.message);
        this.closeDisableDialog();
        this.getList();
      }
    },
    async enableCustomer(row) {
      this.$confirm(`确定要启用企业【${row.unitName}】？`, `启用确认提示`, {
        closeOnClickModal: false,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(async () => {
          const res = await statusCustomer({
            id: row.id,
            status: 1,
          });
          if (res.code == "000000") {
            this.$message.success(res.message);
            this.getList();
          }
        })
        .catch(() => {});
    },
    async openShareDialog(row) {
      this.shareDialogVisible = true;
      this.shareCustomerId = row && row.id;
    },
    openSyncErpDialog(row) {
      this.syncErpDialogVisible = true;
      this.syncErpCustomerId = row && row.id;
    },
    onShareSuccess() {
      this.getList();
    },
    onSyncErpSuccess() {
      this.getList();
    },
    //**数据已更新  */
    onSubmitted() {
      this.getList();
      // this.openShareDialog(this.currentRow);
    },
  },
};
</script>

<style lang="scss" scoped>
.status-reason-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  border: 1px solid #c0c4cc;
  border-radius: 50%;
  color: #c0c4cc;
  font-size: 12px;
  line-height: 12px;
  cursor: help;
  user-select: none;
}
</style>
